import { defa }          from 'defa-object';
import { DateConverter } from 'scripts/utils/date-converter';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.DayAndNightSetting
 * The DEFA DayAndNightSetting model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	homeAutomation : '/homeAutomation/masterControl?attrs=',
};

const DayAndNightSetting = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.homeAutomation + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			dayStartTime     : null,
			dayStartTimeError: null,
			
			nightStartTime   : null,
			nightStartTimeError: null,
			
			nightModeEnabled : null,
			nightModeEnabledError: null,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		if(response) {
			let newModelAttributes = {};
			if(response.dayStartTime){
				this.parseAttribute('dayStartTime', response.dayStartTime, options, newModelAttributes);
				if('success' === response.dayStartTime.status && newModelAttributes.dayStartTime) {
					newModelAttributes.dayStartTime = DateConverter.fromUTCTimeToLocalTime(newModelAttributes.dayStartTime)
				}
			}
			if(response.nightStartTime){
				this.parseAttribute('nightStartTime', response.nightStartTime, options, newModelAttributes);
				if('success' === response.nightStartTime.status && newModelAttributes.nightStartTime) {
					newModelAttributes.nightStartTime = DateConverter.fromUTCTimeToLocalTime(newModelAttributes.nightStartTime)
				}
			}
			if(response.nightModeEnabled){
				this.parseAttribute('nightModeEnabled', response.nightModeEnabled, options, newModelAttributes)
			}
			
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'dayAndNightSettings' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return {dayStartTime : DateConverter.fromLocalTimeToUTCTime(this.get('dayTime')),
			nightStartTime: DateConverter.fromLocalTimeToUTCTime(this.get('nightTime')),
			nightModeEnabled: 'ON' === this.get('timeModeEnabled') };
	},
	
	getAttributes: function() {
		return 'dayStartTime,nightStartTime,nightModeEnabled';
	},
	
	_getDependentModels: function(){
		let self = this;
		let dependentModels = [];
		let allZones = channel.request('zoneHolders').get(self.get('id')).get('zones');
		for(let index in allZones){
			let mode = allZones[index].getModel('5').get('zoneMode');
			if('thermostat' === mode){
				dependentModels.push(allZones[index].getModel('3'));
			}else if('regulator' === mode){
				dependentModels.push(allZones[index].getModel('4'));
			}
		}
		return dependentModels;
	},
} );

export default DayAndNightSetting;
